module.exports = __webpack_public_path__ + "img/facebook.68b60a26.svg";